var publicPath = __webpack_public_path__;
                    module.exports = {
                        symbol: publicPath + 'sprite.svg#icon-burger',
                        view: publicPath + 'sprite.svg#view-icon-burger',
                        viewBox: '0 0 40 40',
                        title: 'icons/fonctions/burger',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };